export const RESOURCES_ROUTES = new Map([
  [
    "BLOG_LIST",
    {
      DESCRIPTION: "resources.blog.description",
      ID: "_blog",
      ICON: "article",
      ITEMS: [],
      LABEL: "resources.blog.label",
      PATH: "/blog",
      VALUE: "blog",
    },
  ],
  [
    "EVENTS_LIST",
    {
      DESCRIPTION: "resources.events.description",
      ID: "_events",
      ICON: "calendar",
      ITEMS: [],
      LABEL: "resources.events.label",
      PATH: "/events",
      VALUE: "events",
    },
  ],
]);

export const MAIN_ROUTES = new Map([
  [
    "ABOUT",
    {
      ID: "_about",
      ITEMS: [],
      LABEL: "about",
      PATH: "/#_about",
      VALUE: "about",
    },
  ],
  [
    "BLOG",
    {
      ICON: "",
      LABEL: "",
      PATH: "/blog/:blogPath",
    },
  ],
  [
    "PROJECT",
    {
      ICON: "",
      LABEL: "",
      PATH: "/projects/:projectPath",
    },
  ],
  [
    "CONTACT",
    {
      ID: "_contact",
      ITEMS: [],
      LABEL: "contact",
      PATH: "/contact",
      VALUE: "contact",
    },
  ],
  [
    "EVENT",
    {
      LABEL: "",
      PATH: "/events/:eventPath",
    },
  ],
  [
    "FEATURES",
    {
      ID: "_features",
      ITEMS: [],
      LABEL: "features",
      PATH: "/features",
      VALUE: "features",
    },
  ],
  [
    "HOME",
    {
      ID: "_home",
      ITEMS: [],
      LABEL: "home",
      PATH: "/",
      VALUE: "home",
    },
  ],
  [
    "INTRODUCTION",
    {
      ID: "_introduction",
      ITEMS: [],
      LABEL: "introduction",
      PATH: "/introduction",
      VALUE: "introduction",
    },
  ],
  [
    "OVERVIEW",
    {
      ID: "_overview",
      ITEMS: [],
      LABEL: "overview",
      PATH: "/#_overview",
      VALUE: "overview",
    },
  ],
  [
    "PARTNERS",
    {
      ID: "_partners",
      ITEMS: [],
      LABEL: "partners",
      PATH: "/#_partners",
      VALUE: "partners",
    },
  ],
  [
    "PEOPLE",
    {
      ID: "_people",
      ITEMS: [],
      LABEL: "people",
      PATH: "/people",
      VALUE: "people",
    },
  ],
  [
    "PUBLICATIONS",
    {
      ID: "_publications",
      ITEMS: [],
      LABEL: "publications",
      PATH: "/publications",
      VALUE: "publications",
    },
  ],
  [
    "PROJECTS",
    {
      ID: "_projects",
      ITEMS: [],
      LABEL: "projects",
      PATH: "/projects",
      VALUE: "projects",
    },
  ],
  [
    "RESOURCES",
    {
      ID: "_resources",
      ITEMS: Array.from(RESOURCES_ROUTES),
      LABEL: "resources.label",
      PATH: "/resources",
      VALUE: "resources",
    },
  ],
  [
    "GITHUB",
    {
      EXTERNAL: true,
      ID: "_github",
      ITEMS: [],
      LABEL: "github",
      PATH: "https://github.com/neurdb/neurdb",
      VALUE: "github",
    },
  ],
]);
